// Canned responses so the PWA runs before cid-agent-server exists. Toggle with VITE_USE_MOCKS.
// Shapes match cid-agent-pwa/docs/TECHNICAL_PRD.md + the page-build conventions. Any /api/agent
// GET not matched below returns a graceful empty envelope so no screen errors. Delete this file
// once the real /api/agent endpoints are live.
const ok = (data, pagination) => ({ success: true, message: 'ok', data, ...(pagination ? { pagination } : {}) });
const page = (rows, cfg) => {
  const p = cfg.params || {};
  const pg = Number(p.page || 1);
  const limit = Number(p.limit || 10);
  const start = (pg - 1) * limit;
  return ok(rows.slice(start, start + limit), { page: pg, limit, total: rows.length, totalPages: Math.max(1, Math.ceil(rows.length / limit)) });
};

const AGENT = { id: 'agent-nadia', email: 'nadia@cidrealtors.com', full_name: 'Nadia Rahman', display_name: 'Nadia Rahman', ren_no: '12345', ren_status: 'REGISTERED', gci_tier: 80, management_rank: 'AGENT', branch_id: 'br-1', phone: '012-333 4455', bank_account_number: '3240 7796 06', bank_account_name: 'NADIA BINTI RAHMAN', address: '12, Jalan Bangsar, 59000 KL' };

const SUMMARY = { agent: AGENT,
  gci: { collected: 148320, ytd: 148320, lifetime: 312400 },
  tier: { current: 80, next: 85, basis: 'lifetime', belowBand: false, floor: 200000, target: 300000, progress: 312400, progressPct: 100, toNext: 0 },
  money: { entitled: 204500, locked: 23900, released: 96400, paid: 84200, paidThisYear: 61300, hasLedger: true },
  closingsThisMonth: 3, leaderboard: { rank: 7, of: 142, ranked: true },
  badges: { coShare: 2 },
  needsYouPreview: 3, needsYouTotal: 4,
  needsYou: [
    { kind: 'ren', tone: 'warn', text: 'REN 12345 expires in 28 days', sub: 'Renew before 10 Sep', to: '/profile' },
    { kind: 'unpaid', tone: 'warn', text: 'SS-202600151 — nothing received yet', sub: 'Invoice raised 26 days ago', to: '/sales/s1' },
    { kind: 'letter', tone: 'bad', text: 'Co-agency letter DPSB-CA 26-00005 was rejected', sub: 'Fix and re-issue', to: '/letters/l2' },
    { kind: 'form', tone: 'accent', text: 'OTP-26-00018 is still unsigned', sub: 'Sent 3 days ago', to: '/forms/f1' },
  ],
  recent: [
    { id: 'n1', t: 'Commission released on SS-202600151', d: 'RM 12,960 unlocked · 2h ago', to: '/sales/s1', unread: true },
    { id: 'n2', t: 'Sale SS-202600142 completed', d: 'Yesterday', to: '/sales/s2', unread: false },
    { id: 'n3', t: 'New downline recruit — Siti L.', d: '2 days ago', to: '/team', unread: false },
  ] };

// Earnings has its OWN shape (earnings.service.getSummary) and only ever
// overlapped with home's by coincidence — one fixture used to serve both, so
// reshaping the home payload silently rendered "[object Object]% tier" here.
const EARNINGS_SUMMARY = {
  agent: { id: AGENT.id, full_name: AGENT.full_name, display_name: AGENT.display_name },
  tier: 80, ytdGci: 148320, lifetimeGci: 312400, nextTier: 85, toNextTier: 52000,
  entitled: 204500, released: 96400, pending: 23900, paid: 84200,
};

// Co-share arrived after this mock layer was written, so it had no fixture at all
// and every co-share screen fell through to the empty-envelope fallback — which
// also meant the More badge read 0 while Home's read 2. `actionable` here is the
// same pending + accepted the servers compute, so the two badges agree.
const CO_SHARE_SUMMARY = { incoming_pending: 1, incoming_accepted: 1, outgoing_pending: 1, outgoing_accepted: 0, actionable: 2 };
const CO_SHARE = {
  incoming: [
    { id: 'cs1', status: 'PENDING', created_at: '2026-08-11T02:10:00Z', proposed_split_percentage: 50, agreed_split_percentage: null,
      requester: { id: 'a9', name: 'Faizal Omar' }, lister: { id: AGENT.id, name: AGENT.full_name },
      listing: { id: 'l1', listing_ref: 'LST-26-00042', property_title: 'Eco Ardence 2, Setia Alam', area: 'Setia Alam', state: 'Selangor', asking_price_rm: 780000, cover_image_url: null } },
    { id: 'cs2', status: 'ACCEPTED', created_at: '2026-08-06T08:30:00Z', proposed_split_percentage: 50, agreed_split_percentage: 60,
      requester: { id: 'a4', name: 'Lim Zhi Hao' }, lister: { id: AGENT.id, name: AGENT.full_name },
      listing: { id: 'l2', listing_ref: 'LST-26-00031', property_title: 'Verve Suites, Mont Kiara', area: 'Mont Kiara', state: 'Kuala Lumpur', asking_price_rm: 920000, cover_image_url: null } },
  ],
  outgoing: [
    { id: 'cs3', status: 'PENDING', created_at: '2026-08-09T01:05:00Z', proposed_split_percentage: 40, agreed_split_percentage: null,
      requester: { id: AGENT.id, name: AGENT.full_name }, lister: { id: 'a7', name: 'Nurul Aisyah' },
      listing: { id: 'l3', listing_ref: 'LST-26-00058', property_title: 'Bandar Rimbayu Phase 3', area: 'Telok Panglima Garang', state: 'Selangor', asking_price_rm: 645000, cover_image_url: null } },
  ],
};

const SALES = [
  { id: 's1', ref: 'SS-202600151', title: 'Bangsar · 3-storey link', type: 'Subsales', status: 'Converted', clabel: 'Converted', stageLabel: 'Balance', priceF: 'RM 1,200,000.00', closed: '12 Jun' },
  { id: 's2', ref: 'SS-202600142', title: 'Mont Kiara · Verve Suites', type: 'Subsales', status: 'Completed', clabel: 'Completed', stageLabel: 'Completion', priceF: 'RM 920,000.00', closed: '02 Jun' },
  { id: 's3', ref: 'RN-202600088', title: 'Cheras · Midah Court', type: 'Rent', status: 'Pending', clabel: 'Pending', stageLabel: 'Draft', priceF: 'RM 2,300.00 /mo', closed: '—' },
  { id: 's4', ref: 'SS-202600131', title: 'Damansara · Tropicana Gardens', type: 'Subsales', status: 'Converted', clabel: 'Converted', stageLabel: 'On terms', priceF: 'RM 1,680,000.00', closed: '20 May' },
];
const SALE_DETAIL = { s1: { id: 's1', ref: 'SS-202600151', title: 'Bangsar · 3-storey link', type: 'Subsales', status: 'Converted', priceF: 'RM 1,200,000.00', stageLabel: 'Balance',
  parties: { vendor: 'Ahmad bin Ali', purchaser: 'Chua Holdings Sdn Bhd', coAgency: '—' },
  commissions: [{ id: 'c1', kind: 'Personal commission', amount: 'RM 21,600.00', unlocked: 'RM 12,960.00', chip: 'Partial' }, { id: 'c2', kind: 'Override · Gen 1 (Faiz A.)', amount: 'RM 1,440.00', unlocked: 'RM 864.00', chip: 'Partial' }],
  receipts: [{ id: 'r1', label: 'Booking · 2%', amount: 'RM 24,000.00', chip: 'Validated' }, { id: 'r2', label: 'Balance deposit', amount: 'RM 96,000.00', chip: 'Pending' }],
  atts: [{ id: 'a1', name: 'SPA - executed.pdf', note: 'AI-matched: 2 parties' }],
  comments: [{ id: 'm1', who: '@finance', body: 'Booking receipt validated ✓', when: '2h ago' }, { id: 'm2', who: 'You', body: 'Uploaded the executed SPA', when: '1d ago' }] } };

// Comment thread in the shape GET /sales/:id/notes returns — rich content_json,
// replies, reactions and attachments, so mock mode exercises the same renderer.
// The two ERP rows are the realistic majority case (97% of production notes) and
// render as compact one-line events rather than comments.
const SALE_NOTES = [
  {
    id: 'sys1', sale_id: 's1', parent_note_id: null, is_system: true,
    content: '[Smith Wong] has changed stage to [Ready to claim]', content_json: null,
    author_id: 'admin-erp', author_type: 'ADMIN', author: { id: 'admin-erp', full_name: 'ERP IMPORT', user_type: 'ADMIN' },
    is_edited: false, is_deleted: false, created_at: new Date(Date.now() - 2.6e8).toISOString(),
    reactions: {}, attachments: [], replies: [], mine: false, who: 'ERP IMPORT', when: '3d ago',
  },
  {
    id: 'sys2', sale_id: 's1', parent_note_id: null, is_system: true,
    content: '[Smith Wong] has attached file "NO 123A TKT 1 BLK G PLAZA JE.pdf".', content_json: null,
    author_id: 'admin-erp', author_type: 'ADMIN', author: { id: 'admin-erp', full_name: 'ERP IMPORT', user_type: 'ADMIN' },
    is_edited: false, is_deleted: false, created_at: new Date(Date.now() - 2.5e8).toISOString(),
    reactions: {}, attachments: [], replies: [], mine: false, who: 'ERP IMPORT', when: '3d ago',
  },
  {
    id: 'm1', sale_id: 's1', parent_note_id: null,
    content: 'Booking receipt validated ✓ @Nadia Rahman',
    content_json: { type: 'doc', content: [{ type: 'paragraph', content: [
      { type: 'text', marks: [{ type: 'bold' }], text: 'Booking receipt validated' },
      { type: 'text', text: ' — thanks ' },
      { type: 'mention', attrs: { id: 'agent-nadia', label: 'Nadia Rahman' } },
    ] }] },
    author_id: 'admin-1', author_type: 'ADMIN', author: { id: 'admin-1', full_name: 'Finance HQ', user_type: 'ADMIN' },
    is_edited: false, is_deleted: false, created_at: new Date(Date.now() - 7.2e6).toISOString(),
    reactions: { thumbs_up: { count: 1, users: ['Nadia Rahman'], reacted: true } },
    attachments: [],
    replies: [{
      id: 'm1r1', sale_id: 's1', parent_note_id: 'm1', content: 'Noted, thank you!', content_json: null,
      author_id: 'agent-nadia', author_type: 'AGENT', author: { id: 'agent-nadia', full_name: 'Nadia Rahman', user_type: 'AGENT' },
      is_edited: false, is_deleted: false, created_at: new Date(Date.now() - 6.9e6).toISOString(),
      reactions: {}, attachments: [], replies: [], mine: true, who: 'You', body: 'Noted, thank you!', when: '1h ago',
    }],
    mine: false, who: 'Finance HQ', body: 'Booking receipt validated ✓', when: '2h ago',
  },
  {
    id: 'm2', sale_id: 's1', parent_note_id: null,
    content: 'Uploaded the executed SPA. Vendor signed on page 14, purchaser IC copies are in the same file.',
    content_json: null,
    author_id: 'agent-nadia', author_type: 'AGENT', author: { id: 'agent-nadia', full_name: 'Nadia Rahman', user_type: 'AGENT' },
    is_edited: true, is_deleted: false, created_at: new Date(Date.now() - 8.64e7).toISOString(),
    reactions: {},
    attachments: [{ id: 'na1', note_id: 'm2', file_name: 'SPA - executed.pdf', file_size_bytes: 2515000, mime_type: 'application/pdf', url: '' }],
    replies: [],
    mine: true, who: 'You', body: 'Uploaded the executed SPA', when: '1d ago',
  },
  {
    // Three minutes after m2 and from the same author — exercises message grouping.
    id: 'm2b', sale_id: 's1', parent_note_id: null,
    content: 'Stamping is booked for Thursday too.', content_json: null,
    author_id: 'agent-nadia', author_type: 'AGENT', author: { id: 'agent-nadia', full_name: 'Nadia Rahman', user_type: 'AGENT' },
    is_edited: false, is_deleted: false, created_at: new Date(Date.now() - 8.622e7).toISOString(),
    reactions: {}, attachments: [], replies: [],
    mine: true, who: 'You', body: 'Stamping is booked for Thursday too.', when: '1d ago',
  },
  {
    id: 'm3', sale_id: 's1', parent_note_id: null,
    content: 'This comment has been deleted', content_json: null,
    author_id: 'agent-nadia', author_type: 'AGENT', author: { id: 'agent-nadia', full_name: 'Nadia Rahman', user_type: 'AGENT' },
    is_edited: false, is_deleted: true, created_at: new Date(Date.now() - 9.0e7).toISOString(),
    reactions: {}, attachments: [], replies: [],
    mine: true, who: 'You', body: 'This comment has been deleted', when: '1d ago',
  },
];
// Filler history so mock mode has enough pages to exercise scroll-up pagination.
// Older than everything above, and newest-first like the server returns.
const SALE_NOTES_HISTORY = Array.from({ length: 38 }, (_, i) => {
  const age = 3.0e8 + i * 4.2e6; // all older than the handcrafted notes
  const days = Math.round(age / 8.64e7);
  const who = ['ZUL', 'KOMALA', 'Jahnes Choo', 'ATIQAH'][i % 4];
  const what = [
    `has changed stage to [${['Verified', 'Approved', 'Ready to claim', 'Balance'][i % 4]}]`,
    'has attached file "Vertiq 05-19-2024 14-48-17.pdf".',
    `has changed status from [Pending] to [Converted]`,
    'has submitted sales.',
  ][i % 4];
  return {
    id: `hist${i}`, sale_id: 's1', parent_note_id: null, is_system: true,
    content: `[${who}] ${what}`, content_json: null,
    author_id: 'admin-erp', author_type: 'ADMIN', author: { id: 'admin-erp', full_name: 'ERP IMPORT', user_type: 'ADMIN' },
    is_edited: false, is_deleted: false, created_at: new Date(Date.now() - age).toISOString(),
    reactions: {}, attachments: [], replies: [], mine: false, who: 'ERP IMPORT', when: `${days}d ago`,
  };
});

// The full thread the way the server sends it: newest first.
const SALE_NOTES_ALL = [...SALE_NOTES, ...SALE_NOTES_HISTORY]
  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

/** Page the thread newest-first, matching GET /sales/:id/notes. */
const pageNotes = (config) => {
  const p = Number(config.params?.page) || 1;
  const limit = Number(config.params?.limit) || 20;
  const start = (p - 1) * limit;
  return ok(SALE_NOTES_ALL.slice(start, start + limit), {
    page: p, limit, total: SALE_NOTES_ALL.length, pages: Math.ceil(SALE_NOTES_ALL.length / limit),
  });
};

// GET /sales/:id/finance. Keys mirror sale.service.getSaleFinance exactly —
// without this route the Finance tab read `fin.rollup.invoiced` off an empty
// envelope and crashed the whole page in mock mode.
const SALE_FINANCE = {
  rollup: {
    net_gci: 24000, total_commission: 36000,
    received: 120000, held_balance: 96000, invoiced: 144000, invoice_outstanding: 24000,
    my: { entitled: 21600, unlocked: 12960, paid: 12960 },
  },
  client_ac: {
    balance: 96000,
    breakdown: [{
      receipt_id: 'r2', payer: 'Purchaser · Chua Holdings Sdn Bhd',
      fee_type: 'EARNEST_DEPOSIT', fee_label: 'Earnest deposit',
      amount: 120000, remaining_held: 96000, receipt_date: '2026-07-31',
    }],
  },
  invoices: [
    // `payments` are the official receipts raised against the invoice — what the
    // 120,000 already collected was receipted as. No has_pdf: mock mode serves no
    // document bytes, same as the invoice above.
    { id: 'inv1', doc_no: 'INV-26-00121', total: 144000, outstanding: 24000, status: 'PARTIAL', status_label: 'Partial', when: '3d ago',
      payments: [
        { id: 'ko1', or_no: 'OR-26-00341', source: 'SQL', date: '2026-07-31', amount: 120000, status: 'COMPLETED', status_label: 'Receipted', voided: false, has_pdf: false },
      ] },
  ],
  refunds: [],
  cash_movements: [
    { id: 'cm1', from_label: 'Purchaser', to_label: 'Client A/C', purpose_label: 'Commission settlement', amount: 120000, when: '3d ago' },
  ],
};

// Mutable so mock mode shows the badge clearing when the thread is opened.
let noteUnread = 2;

const MENTIONABLE_USERS = [
  { id: 'admin-1', label: 'Finance HQ', user_type: 'ADMIN' },
  { id: 'agent-nadia', label: 'Nadia Rahman', user_type: 'AGENT' },
];
const MENTIONABLE_RESOURCES = [
  { id: 'r1', label: 'RM 24,000 - Chua Holdings', type: 'receipt' },
  { id: 'a1', label: 'SPA - executed.pdf', type: 'attachment' },
];

// Mirrors listing.service._mapListRow: the card shows the attributes an agent
// matches a buyer against, so the fixtures have to carry them too.
const LISTINGS = [
  { id: 'l1', listing_ref: 'PL-202600123', property_title: 'Mont Kiara · Verve Suites 2BR', property_address: 'Jalan Kiara', area: 'Mont Kiara', state: 'Kuala Lumpur', postcode: '50480', property_type: 'Serviced Residence', property_tenure: 'FREEHOLD', listing_type: 'SUBSALE', status: 'ACTIVE', visibility: 'PUBLIC', asking_price_rm: 920000, price_negotiable: true, bedrooms: 2, bathrooms: 2, car_parks: 2, built_up_sqft: 1100, land_area_sqft: null, expired_at: null, cover_image_url: '', image_count: 6 },
  { id: 'l2', listing_ref: 'PL-202600131', property_title: 'Bangsar South · Vista Serviced', property_address: 'Jalan Kerinchi', area: 'Bangsar South', state: 'Kuala Lumpur', postcode: '59200', property_type: 'Serviced Residence', property_tenure: 'LEASEHOLD', listing_type: 'RENT', status: 'DRAFT', visibility: 'INTERNAL', asking_price_rm: 2800, price_negotiable: false, bedrooms: 1, bathrooms: 1, car_parks: 1, built_up_sqft: 620, land_area_sqft: null, expired_at: null, cover_image_url: '', image_count: 3 },
  { id: 'l3', listing_ref: 'PL-202600140', property_title: 'Cheras · Midah Court', property_address: 'Jalan Midah', area: 'Cheras', state: 'Kuala Lumpur', postcode: '56000', property_type: 'Apartment', property_tenure: 'FREEHOLD', listing_type: 'SUBSALE', status: 'DRAFT', visibility: 'INTERNAL', asking_price_rm: 560000, price_negotiable: true, bedrooms: 3, bathrooms: 2, car_parks: 1, built_up_sqft: 950, land_area_sqft: null, expired_at: null, cover_image_url: '', image_count: 0 },
];
const LISTING_DETAIL = {
  l1: {
    ...LISTINGS[0],
    furnish: 'PARTIALLY_FURNISHED',
    facing: 'North-East',
    floor_level: '18',
    description: 'Corner unit with an unblocked KLCC view, renovated wet kitchen and two side-by-side car parks. Walking distance to Publika.',
    features: { gated_guarded: true, swimming_pool: true, gymnasium: true, renovated: true },
    published_at: '2026-04-04T02:00:00.000Z',
    owner_name: 'Tan Sri Lim',
    owner_phone: '012-777 8899',
    owner_email: 'lim@example.com',
    images: [{ id: 'i1', image_url: '', is_cover: true }, { id: 'i2', image_url: '', is_cover: false }],
    agents: [{ agent_id: 'agent-nadia', name: 'Nadia Rahman', is_primary: true }],
    authorization_form: { form_ref: 'ALS-26-00009', status: 'APPROVED' },
  },
  // RENT + DRAFT: exercises the /month price suffix and the locked visibility
  // toggle (a draft is private, so there is nothing to set).
  l2: {
    ...LISTINGS[1],
    furnish: 'FULLY_FURNISHED',
    facing: 'South',
    floor_level: '7',
    description: 'Fully furnished one-bedroom with a pool view, walking distance to the LRT.',
    features: { gymnasium: true, swimming_pool: true },
    owner_name: 'Sarah Abdullah',
    owner_phone: '019-330 1188',
    images: [{ id: 'i3', image_url: '', is_cover: true }],
    agents: [{ agent_id: 'agent-nadia', name: 'Nadia Rahman', is_primary: true }],
  },
  // DRAFT: visibility locked, and the submit-for-review / discard confirmations.
  l3: {
    ...LISTINGS[2],
    furnish: 'UNFURNISHED',
    description: 'Corner apartment, needs light renovation.',
    features: {},
    owner_name: 'Chong Kok Wai',
    owner_phone: '016-220 4477',
    images: [],
    agents: [{ agent_id: 'agent-nadia', name: 'Nadia Rahman', is_primary: true }],
  },
  // Another agent's listing (co-broke). Shaped exactly as the server returns it for
  // read_only: owner_name / owner_phone / owner_email are NULL — the vendor's
  // details are redacted server-side and never reach the client — and the contact
  // that replaces them is the listing agent's. Keep those nulls: this fixture is
  // what proves the redaction on the screen it matters on.
  l4: {
    ...LISTINGS[0],
    id: 'l4',
    listing_ref: 'PL-202600155',
    property_title: 'Desa ParkCity · Zeta',
    property_address: 'Jalan Residen',
    area: 'Desa ParkCity',
    visibility: 'PUBLIC',
    furnish: 'FULLY_FURNISHED',
    facing: 'East',
    description: 'Facing the park, walking distance to the waterfront.',
    features: { gated_guarded: true, playground: true },
    owner_name: null,
    owner_phone: null,
    owner_email: null,
    images: [{ id: 'i9', image_url: '', is_cover: true }],
    read_only: true,
    is_mine: false,
    agent_name: 'Faiz Abdullah',
    listing_agent: { name: 'Faiz Abdullah', phone: '013-284 5510', email: 'faiz@cidrealtors.com', is_hq: false },
    is_hq_listing: false,
    agents: [{ agent_id: 'agent-faiz', name: 'Faiz Abdullah', is_primary: true }],
  },
};

// Full postal addresses, as the server actually returns them — the earnings card
// trims them to street + area, so a short fixture would hide that. One row per chip
// state so all five render in mock mode.
const EARN_BY_SALE = [
  { id: 'e1', sale_ref: 'SS-202600151', property: 'No. 8, Jalan Maarof, Bangsar, 59100 Kuala Lumpur', kind: 'Personal', entitled: 21600, unlocked: 12960, paid: 12960, chip: 'Part paid' },
  { id: 'e2', sale_ref: 'SS-202600142', property: 'A-12-3, Verve Suites, Mont Kiara, 50480 Kuala Lumpur', kind: 'Personal', entitled: 18400, unlocked: 18400, paid: 18400, chip: 'Paid' },
  { id: 'e3', sale_ref: 'SS-202600131', property: 'No. 15, Jalan Damansara Endah, Damansara Heights, 50490 Kuala Lumpur', kind: 'Personal', entitled: 30240, unlocked: 15120, paid: 0, chip: 'Part released' },
  { id: 'e4', sale_ref: 'SS-202600128', property: 'No. 61, Jalan USJ 11/3D, UEP Subang Jaya, 47620 Subang Jaya, Selangor', kind: 'Personal', entitled: 12800, unlocked: 12800, paid: 0, chip: 'Released' },
  { id: 'e5', sale_ref: 'RT-202600117', property: 'Blok C-12-3, Cheras Sentral, Jalan Cheras, 56000 Kuala Lumpur', kind: 'Personal', entitled: 1320, unlocked: 0, paid: 0, chip: 'Locked' },
];
// The full per-recipient split behind one deal — what the Earnings commission sheet
// draws. recipient_id is what marks the caller's own line as "You"; the personal
// line's amount matches EARN_BY_SALE e1 so the sheet header and list agree.
const COMM_BREAKDOWN = {
  items: [
    { id: 'cb1', commission_type: 'PERSONAL_COMMISSION', recipient_type: 'AGENT', recipient_id: 'agent-nadia', recipient_name: 'Nadia Rahman', rate: 0.8, amount: 21600, unlocked_amount: 12960, paid_amount: 12960, description: null },
    { id: 'cb2', commission_type: 'STANDARD_OVERRIDE', recipient_type: 'AGENT', recipient_id: 'agent-hafiz', recipient_name: 'Hafiz Osman', rate: 0.05, amount: 1350, unlocked_amount: 810, paid_amount: 810, description: 'Gen 1 upline' },
    { id: 'cb3', commission_type: 'HQ_ROYALTY', recipient_type: 'HQ', recipient_id: null, recipient_name: 'HQ', rate: 0.04, amount: 1080, unlocked_amount: 648, paid_amount: 648, description: null },
    { id: 'cb4', commission_type: 'BRANCH_REMAINDER', recipient_type: 'BRANCH', recipient_id: 'br-1', recipient_name: 'Bangsar', rate: 0.06, amount: 1620, unlocked_amount: 972, paid_amount: 972, description: null },
  ],
  total_amount: 25650, total_unlocked: 15390, total_paid: 15390,
  net_gci: 27000, balance: 1350, is_legacy: false, is_preview: false,
};
// The statement document's source — the same five deals as EARN_BY_SALE, with the
// sale dates and full addresses the printed statement lists.
const STATEMENT_BASE = {
  agent: { id: 'agent-nadia', name: 'Nadia Rahman', ren_no: '12345', tier: 80 },
  commissions: [
    { sale_ref: 'SS-202600151', property: 'No. 8, Jalan Maarof, Bangsar, 59100 Kuala Lumpur', sale_date: '2026-06-12', deal_type: 'SUBSALE', entitled: 21600, released: 12960, paid: 12960 },
    { sale_ref: 'SS-202600142', property: 'A-12-3, Verve Suites, Mont Kiara, 50480 Kuala Lumpur', sale_date: '2026-06-02', deal_type: 'SUBSALE', entitled: 18400, released: 18400, paid: 18400 },
    { sale_ref: 'SS-202600131', property: 'No. 15, Jalan Damansara Endah, Damansara Heights, 50490 Kuala Lumpur', sale_date: '2026-05-20', deal_type: 'SUBSALE', entitled: 30240, released: 15120, paid: 0 },
    { sale_ref: 'SS-202600128', property: 'No. 61, Jalan USJ 11/3D, UEP Subang Jaya, 47620 Subang Jaya, Selangor', sale_date: '2026-04-28', deal_type: 'SUBSALE', entitled: 12800, released: 12800, paid: 0 },
    { sale_ref: 'RT-202600117', property: 'Blok C-12-3, Cheras Sentral, Jalan Cheras, 56000 Kuala Lumpur', sale_date: '2026-03-16', deal_type: 'RENT', entitled: 1320, released: 0, paid: 0 },
  ],
  // EARN_OVR is declared further down, so this stays a getter rather than a
  // reference evaluated at module-init time (const is in its TDZ up there).
  get overrides() { return EARN_OVR; },
  payouts: [{ id: 'pt1', period: 'Jun 2026', payout_date: '2026-06-30', amount: 31360, status: 'ACTIVE', cheque_number: '400271' }],
  totals: { entitled: 84360, released: 59280, paid: 31360, pending: 27920, override: 608, payouts: 31360, deals: 5 },
};
// The server labels the period; the mock does the same so the picker, the page and
// the printed document never disagree about which period is on screen.
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dayLabel = (s) => `${Number(s.slice(8, 10))} ${MON[Number(s.slice(5, 7)) - 1]} ${s.slice(0, 4)}`;
const periodLabelMock = (from, to) => {
  if (!from && !to) return 'All time';
  if (from && to) {
    if (from.slice(0, 4) === to.slice(0, 4) && from.slice(5) === '01-01' && to.slice(5) === '12-31') return `Year ${from.slice(0, 4)}`;
    if (from.slice(0, 7) === to.slice(0, 7) && from.slice(8) === '01') return `${MON[Number(from.slice(5, 7)) - 1]} ${from.slice(0, 4)}`;
    return `${dayLabel(from)} – ${dayLabel(to)}`;
  }
  return from ? `From ${dayLabel(from)}` : `Until ${dayLabel(to)}`;
};
// HQ letterhead (document_settings) — one global row, shared by the co-agency
// letters and the commission statement.
const DOC_SETTINGS = {
  company_name: 'CID Realtors Sdn Bhd',
  company_registration_no: '202001012345 (1372845-X)',
  company_address: 'Level 8, Menara CID, No. 1 Jalan Ampang\n50450 Kuala Lumpur, Malaysia',
  company_phone: '03-2181 8888',
  company_email: 'hq@cidrealtors.com',
  company_website: 'cidrealtors.com',
  sst_no: 'W10-1808-32000123',
  company_logo_url: '/cid_fulllogo.png',
  license_type: 'Registered Estate Agency',
  license_no: 'E(3)1234',
  signatory_name: 'Lee Chee Meng',
  signatory_title: 'Head of Finance',
  signatory_ren_no: 'REN 00123',
};
// Totals agree with EARN_BY_SALE: earned 84,360 · released 59,280 · paid 31,360.
const EARN_PERIOD = { from: null, to: null, earned: 84360, released: 59280, paid: 31360, pending: 27920, personal: 84360, override: 608, deals: 5, payouts: 31360 };
const EARN_OVR = [
  { id: 'o1', from: 'Faiz A.', gen: 1, sale_ref: 'SS-202600149', amount: 368 },
  { id: 'o2', from: 'Siti L.', gen: 1, sale_ref: 'SS-202600150', amount: 240 },
];
const LEDGER = { remaining_balance: 23900, total_due: 108100, total_paid: 84200, total_clawback: 0, status: 'PARTIAL' };
const STATEMENTS = [{ id: 'st1', period: 'Jun 2026', amount: 31840 }, { id: 'st2', period: 'May 2026', amount: 27200 }];
const TIER_LADDER = [
  { tier: 60, threshold: 0, current: false, unlocked: true }, { tier: 65, threshold: 25000, current: false, unlocked: true },
  { tier: 70, threshold: 50000, current: false, unlocked: true }, { tier: 75, threshold: 100000, current: false, unlocked: true },
  { tier: 80, threshold: 200000, current: true, unlocked: true }, { tier: 85, threshold: 300000, current: false, unlocked: false },
];

const FORMS = [
  { id: 'f1', form_ref: 'OTP-26-00018', form_type: 'OTP', status: 'Pending signing', property: 'Bangsar · 3-storey link' },
  { id: 'f2', form_ref: 'OTR-26-00006', form_type: 'OTR', status: 'Signed', property: 'Cheras · Midah Court' },
  { id: 'f3', form_ref: 'ALS-26-00009', form_type: 'ALS', status: 'Approved', property: 'Mont Kiara · Verve' },
];
const FORM_DETAIL = { f1: { id: 'f1', form_ref: 'OTP-26-00018', form_type: 'OTP', status: 'Pending signing', property: 'Bangsar · 3-storey link', signatories: [{ role: 'Purchaser 1', name: 'Chua Holdings', state: 'signed', at: '9:12am' }, { role: 'Vendor 1', name: 'Ahmad bin Ali', state: 'sent', at: 'awaiting OTP' }], witnesses: [{ role: 'Witness', name: '', nric: '' }], pdf_url: '' } };

const LETTERS = [
  { id: 'la', letter_ref: 'DPSB-CA 26-00007', co_agency: 'Dynasty Property SB', status: 'Verified', cid_share: 70, ca_share: 30 },
  { id: 'l2', letter_ref: 'DPSB-CA 26-00005', co_agency: 'Prime Estates SB', status: 'Rejected', cid_share: 60, ca_share: 40 },
];
const LETTER_DETAIL = { l2: { id: 'l2', letter_ref: 'DPSB-CA 26-00005', status: 'Rejected', co_agency: 'Prime Estates SB', cid_share: 60, ca_share: 40, timeline: [{ state: 'Submitted', at: '02 Jun', note: '' }, { state: 'Rejected', at: '04 Jun', note: 'Split needs HQ review' }], signed_document_url: null, rejection_reason: 'Commission split requires director sign-off', body_html: '<p>Co-agency agreement…</p>' }, la: { id: 'la', letter_ref: 'DPSB-CA 26-00007', status: 'Verified', co_agency: 'Dynasty Property SB', cid_share: 70, ca_share: 30, timeline: [{ state: 'Submitted', at: '20 May', note: '' }, { state: 'Verified', at: '21 May', note: '' }], signed_document_url: 'signed.pdf', rejection_reason: null, body_html: '<p>Co-agency agreement…</p>' } };

const CONTACTS = {
  vendor: [{ id: 'v1', name: 'Ahmad bin Ali', entity_type: 'INDIVIDUAL', phone: '012-111 2233', code: 'D-000123' }, { id: 'v2', name: 'Lim Holdings Sdn Bhd', entity_type: 'COMPANY', phone: '03-2222 3333', code: null }],
  purchaser: [{ id: 'p1', name: 'Chua Holdings Sdn Bhd', entity_type: 'COMPANY', phone: '03-4444 5555', code: 'D-000456' }],
  coagency: [{ id: 'ca1', name: 'Dynasty Property SB', entity_type: 'COMPANY', phone: '03-6666 7777', code: 'C-000078' }],
};
const CONTACT_DETAIL = { v1: { id: 'v1', name: 'Ahmad bin Ali', entity_type: 'INDIVIDUAL', phone: '012-111 2233', email: 'ahmad@example.com', code: 'D-000123', bank_accounts: [{ id: 'b1', bank: 'Maybank', acct: '5140 1234 5678', name: 'Ahmad bin Ali' }], linked_deals: [{ ref: 'SS-202600151', role: 'Vendor' }] } };

const TEAM = { counts: { directActive: 4, postApril: 2 }, overrideRollup: 3240, roadmap: { current: 4, target: 5, daysLeft: 47 }, downline: [
  { agent_id: 'd1', name: 'Faiz Abdullah', gen: 1, tier: 65, gci: 142000 },
  { agent_id: 'd2', name: 'Siti Lestari', gen: 1, tier: 60, gci: 88000 },
  { agent_id: 'd3', name: 'Raj Kumar', gen: 2, tier: 60, gci: 41000 },
  { agent_id: 'd4', name: 'Mei Ling', gen: 2, tier: 60, gci: 22000 },
] };

// Team & Branch performance. The mock caller is a Team Leader with a downline and
// no branch assignment, so `can.branch` is false and the Branch segment never
// renders — the same gate the real /performance/scopes response applies.
const PERF_SCOPES = {
  can: { direct: true, allGens: true, branch: false },
  counts: { direct: 2, allGens: 4, branch: 0 },
  branches: [],
  unassignedCd: true,
};
const PERF_MEMBERS = [
  { agent_id: 'd1', rank: 1, name: 'Faiz Abdullah', gen: 1, management_rank: 'TL', tier: 65, gci: 142000, volume: 7100000, deals: 7, pipeline_gci: 38000, pipeline_deals: 3, override: 12800, last_close: '2026-07-12', dormant: false, is_new: false, is_active: true, is_me: false },
  { agent_id: 'd2', rank: 2, name: 'Siti Lestari', gen: 1, management_rank: 'AGENT', tier: 60, gci: 88000, volume: 4400000, deals: 5, pipeline_gci: 21000, pipeline_deals: 2, override: 7100, last_close: '2026-06-28', dormant: false, is_new: false, is_active: true, is_me: false },
  { agent_id: 'd3', rank: 3, name: 'Raj Kumar', gen: 2, management_rank: 'AGENT', tier: 60, gci: 41000, volume: 2050000, deals: 3, pipeline_gci: 0, pipeline_deals: 0, override: 1900, last_close: '2026-05-04', dormant: false, is_new: false, is_active: true, is_me: false },
  { agent_id: 'd4', rank: 4, name: 'Mei Ling', gen: 2, management_rank: 'AGENT', tier: 60, gci: 0, volume: 0, deals: 0, pipeline_gci: 9000, pipeline_deals: 1, override: 0, last_close: null, dormant: true, is_new: false, is_active: true, is_me: false },
];
const PERF_SUMMARY = {
  scope: 'direct', branch: null,
  period: { from: '2026-01-01', to: '2026-12-31', label: '2026' },
  members: { total: 4, producing: 3, dormant: 1, inactive: 0 },
  gci: 271000, volume: 13550000, deals: 15, avgDeal: 18066.67, avgPerMember: 67750,
  override: 21800,
  pipeline: {
    gci: 68000,
    deals: 6,
    groups: [
      { key: 'DRAFT', label: 'Draft', deals: 1, gci: 9000 },
      { key: 'INVOICE', label: 'Balance & invoice', deals: 2, gci: 21000 },
      { key: 'CLAIM', label: 'Receipt & claim', deals: 2, gci: 26000 },
      { key: 'HQ', label: 'HQ verify & approve', deals: 1, gci: 12000 },
    ],
  },
  branchYtd: null,
};
const PERF_ATTENTION = [
  { kind: 'stuck', tone: 'bad', text: 'SS-202600151 stuck at Request invoice', sub: '41 days · Faiz Abdullah', badge: '41d' },
  { kind: 'dormant', tone: 'warn', text: 'Mei Ling has no closing in 90 days', sub: null, badge: '1' },
];
const PERF_MEMBER = {
  agent: { agent_id: 'd1', name: 'Faiz Abdullah', gen: 1, management_rank: 'TL', tier: 65, ren_no: '12345', join_date: '2024-03-01', is_active: true, is_new: false, dormant: false },
  kpi: { gci: 142000, volume: 7100000, deals: 7, avgDeal: 20285.71, pipeline_gci: 38000, pipeline_deals: 3, last_close: '2026-07-12' },
  override: { amount: 12800, gen: 1, types: ['STANDARD_OVERRIDE'] },
  period: { from: '2026-01-01', to: '2026-12-31', label: '2026' },
  deals: [
    { id: 's1', sale_ref: 'SS-HQ-2026-0184', property: 'Verve Suites, Mont Kiara', deal_type: 'SUBSALES', sale_date: '2026-07-12', status: 'Completed', stage: 'PAID', stage_label: 'Paid', stage_group: null, gross: 980000, gci: 21600, agent_id: 'd1', agent_name: 'Faiz Abdullah' },
    { id: 's2', sale_ref: 'SS-HQ-2026-0163', property: 'The Vertical, Bangsar South', deal_type: 'SUBSALES', sale_date: '2026-06-28', status: 'Converted', stage: 'HQ_APPROVED', stage_label: 'HQ approved', stage_group: 'HQ', gross: 1250000, gci: 27500, agent_id: 'd1', agent_name: 'Faiz Abdullah' },
  ],
  pipeline: [
    { id: 's3', sale_ref: 'SR-HQ-2026-0141', property: 'Binjai 8, KLCC', deal_type: 'RENT', sale_date: '2026-06-09', status: 'Pending', stage: 'READY_TO_CLAIM', stage_label: 'Ready to claim', stage_group: 'CLAIM', gross: 6500, gci: 3900, agent_id: 'd1', agent_name: 'Faiz Abdullah' },
  ],
};

const NOTIFS = [
  { id: 'n1', type: 'commission', title: 'Commission released', body: 'RM 12,960 unlocked on SS-202600151', read_at: null, deep_link: '/sales/s1', at: '2h ago' },
  { id: 'n2', type: 'form', title: 'Signature pending', body: 'Vendor 1 has not signed OTP-26-00018', read_at: null, deep_link: '/forms/f1', at: '5h ago' },
  { id: 'n3', type: 'letter', title: 'Letter rejected', body: 'DPSB-CA 26-00005 was rejected', read_at: '1', deep_link: '/letters/l2', at: 'Yesterday' },
  { id: 'n4', type: 'recruit', title: 'New downline recruit', body: 'Siti L. joined your team', read_at: '1', deep_link: '/team', at: '2 days ago' },
];
const NOTIF_PREFS = { pushOn: false }; // push probe only — category mutes were removed
const DOCS = [{ id: 'dc1', name: 'REN certificate.pdf', type: 'REN', uploaded_at: '2026-01-12' }, { id: 'dc2', name: 'IC (front & back).pdf', type: 'IC', uploaded_at: '2026-01-12' }];

const ROUTES = [
  ['POST', /\/auth\/login$/, () => ok({ agent: AGENT, accessToken: 'mock.access', refreshToken: 'mock.refresh', expiresIn: 900 })],
  ['POST', /\/auth\/refresh$/, () => ok({ agent: AGENT, accessToken: 'mock.access2', refreshToken: 'mock.refresh2', expiresIn: 900 })],
  ['POST', /\/auth\/(forgot-password|logout)$/, () => ok({ ok: true })],
  ['GET', /\/agent\/me$/, () => ok(AGENT)],
  ['GET', /\/me\/documents$/, () => ok(DOCS)],
  ['GET', /\/me\/preferences$/, () => ok({ theme: 'system', bioOn: true, leaderboardOn: true })],
  ['GET', /\/home\/summary$/, () => ok(SUMMARY)],
  ['GET', /\/push\/public-key$/, () => ok({ key: 'BCX3ZMjNsY6TULE2Cphw_pn6yeb8JNxkFwbP-N43_MsNB2di5USDyJYCVr_LV0_qMp_0pZQ_2nsMIK6POppjjmM' })],
  ['POST', /\/push\/register$/, () => ok({ registered: true })],
  ['DELETE', /\/push\/unregister$/, () => ok({ ok: true })],
  ['GET', /\/co-share-requests\/summary$/, () => ok(CO_SHARE_SUMMARY)],
  ['GET', /\/co-share-requests$/, (c) => page(CO_SHARE[(c.params || {}).box === 'outgoing' ? 'outgoing' : 'incoming'], c)],
  ['GET', /\/co-share-requests\/([^/]+)$/, (c, m) => ok([...CO_SHARE.incoming, ...CO_SHARE.outgoing].find((r) => r.id === m[1]) || CO_SHARE.incoming[0])],
  ['GET', /\/agent\/sales$/, (c) => page(SALES, c)],
  ['GET', /\/agent\/sales\/([^/]+)$/, (c, m) => ok(SALE_DETAIL[m[1]] || SALE_DETAIL.s1)],
  ['GET', /\/sales\/[^/]+\/commissions$/, () => ok(SALE_DETAIL.s1.commissions)],
  ['GET', /\/sales\/[^/]+\/commission-breakdown$/, () => ok(COMM_BREAKDOWN)],
  ['GET', /\/sales\/[^/]+\/receipts$/, () => ok(SALE_DETAIL.s1.receipts)],
  ['GET', /\/sales\/[^/]+\/finance$/, () => ok(SALE_FINANCE)],
  ['GET', /\/sales\/[^/]+\/notes\/unread-count$/, () => ok({ count: noteUnread })],
  ['POST', /\/sales\/[^/]+\/notes\/read$/, () => { noteUnread = 0; return ok({ marked: 2, count: 0 }); }],
  ['GET', /\/sales\/[^/]+\/notes\/mentionable-users$/, () => ok(MENTIONABLE_USERS)],
  ['GET', /\/sales\/[^/]+\/notes\/mentionable-resources$/, () => ok(MENTIONABLE_RESOURCES)],
  ['GET', /\/sales\/[^/]+\/notes$/, (c) => pageNotes(c)],
  ['POST', /\/sales\/[^/]+\/notes\/[^/]+\/reactions$/, () => ok({ thumbs_up: { count: 1, users: ['You'], reacted: true } })],
  ['DELETE', /\/sales\/[^/]+\/notes\/[^/]+\/reactions\/[^/]+$/, () => ok({})],
  ['GET', /\/agent\/listings$/, (c) => page(LISTINGS, c)],
  // Spread, don't hand back the fixture itself: a real response is freshly parsed
  // JSON, so its identity differs every call. Returning the same object reference
  // makes React's setState bail out, and any mutate-then-reload flow (visibility,
  // status, cover photo) looks broken when it is actually fine.
  ['GET', /\/agent\/listings\/([^/]+)$/, (c, m) => ok({ ...(LISTING_DETAIL[m[1]] || LISTING_DETAIL.l1) })],
  // Stateful so the toggle can actually be exercised: the detail page reloads
  // after the call and has to see the new value, not the old one.
  ['PUT', /\/agent\/listings\/([^/]+)\/visibility$/, (c, m) => {
    const row = LISTING_DETAIL[m[1]] || LISTING_DETAIL.l1;
    const next = String(JSON.parse(c.data || '{}').visibility || '').toUpperCase();
    if (row.status === 'DRAFT') {
      return { success: false, message: 'A draft is private and has no visibility setting. Publish it first, then choose internal or public.' };
    }
    row.visibility = next;
    return ok(row);
  }],
  ['GET', /\/earnings\/summary$/, () => ok(EARNINGS_SUMMARY)],
  ['GET', /\/earnings\/summary\/period$/, () => ok(EARN_PERIOD)],
  ['GET', /\/earnings\/by-sale$/, (c) => page(EARN_BY_SALE, c)],
  ['GET', /\/earnings\/overrides$/, (c) => page(EARN_OVR, c)],
  ['GET', /\/earnings\/ledger$/, () => ok(LEDGER)],
  ['GET', /\/earnings\/statements$/, (c) => page(STATEMENTS, c)],
  ['GET', /\/earnings\/statement\.csv$/, () => [
    'Sale,Date,Property,Earned,Released,Paid',
    ...STATEMENT_BASE.commissions.map((c) => `${c.sale_ref},${c.sale_date},"${c.property}",${c.entitled},${c.released},${c.paid}`),
  ].join('\n')],
  ['GET', /\/earnings\/statement$/, (c) => {
    const p = c.params || {};
    return ok({ ...STATEMENT_BASE, period: { from: p.from || null, to: p.to || null, label: periodLabelMock(p.from || null, p.to || null) } });
  }],
  ['GET', /\/co-agency-letter-settings$/, () => ok(DOC_SETTINGS)],
  ['GET', /\/career\/tier-ladder$/, () => ok(TIER_LADDER)],
  ['GET', /\/agent\/booking-forms$/, (c) => page(FORMS, c)],
  ['GET', /\/agent\/booking-forms\/([^/]+)$/, (c, m) => ok(FORM_DETAIL[m[1]] || FORM_DETAIL.f1)],
  ['GET', /\/agent\/co-agency-letters$/, (c) => page(LETTERS, c)],
  ['GET', /\/agent\/co-agency-letters\/([^/]+)$/, (c, m) => ok(LETTER_DETAIL[m[1]] || LETTER_DETAIL.la)],
  ['GET', /\/agent\/vendors$/, (c) => page(CONTACTS.vendor, c)],
  ['GET', /\/agent\/purchasers$/, (c) => page(CONTACTS.purchaser, c)],
  ['GET', /\/agent\/co-agencies$/, (c) => page(CONTACTS.coagency, c)],
  ['GET', /\/agent\/(vendors|purchasers|co-agencies)\/([^/]+)$/, (c, m) => ok(CONTACT_DETAIL[m[2]] || CONTACT_DETAIL.v1)],
  ['GET', /\/team\/tree$/, () => ok(TEAM)],
  ['GET', /\/team\/recruits$/, (c) => page(TEAM.downline, c)],
  ['GET', /\/team\/overrides$/, (c) => page(EARN_OVR, c)],
  ['GET', /\/career\/roadmap$/, () => ok(TEAM.roadmap)],
  ['GET', /\/performance\/scopes$/, () => ok(PERF_SCOPES)],
  ['GET', /\/performance\/summary$/, () => ok(PERF_SUMMARY)],
  ['GET', /\/performance\/members$/, (c) => page(PERF_MEMBERS, c)],
  ['GET', /\/performance\/members\/([^/]+)$/, () => ok(PERF_MEMBER)],
  ['GET', /\/performance\/deals$/, (c) => page(PERF_MEMBER.deals, c)],
  ['GET', /\/performance\/attention$/, () => ok(PERF_ATTENTION)],
  ['GET', /\/notifications$/, (c) => page(NOTIFS, c)],
  ['GET', /\/notifications\/unread-count$/, () => ok({ count: NOTIFS.filter((n) => !n.read_at).length })],
  ['GET', /\/notifications\/preferences$/, () => ok(NOTIF_PREFS)],
  ['POST', /\/simulate\/tier$/, (c) => ok({ reachedTier: 85, gapToNext: 120000, message: 'Closing RM 250k more reaches the 85% tier.' })],
  ['POST', /\/simulate\/commission$/, (c) => ok({ gci: 21600, personal: 17280, overrideTotal: 1440, breakdown: [{ label: 'Personal (80%)', amount: 17280 }, { label: 'HQ royalty', amount: 1080 }, { label: 'Override up-line', amount: 1440 }, { label: 'Branch / CD', amount: 1800 }] })],
  ['POST', /\/simulate\/override-preview$/, () => ok([{ label: 'Gen 1 · Faiz A.', amount: 368 }, { label: 'Gen 1 · Siti L.', amount: 240 }])],
];

export function mockAdapter(fallback) {
  return async (config) => {
    const method = (config.method || 'get').toUpperCase();
    const url = (config.url || '').split('?')[0];
    for (const [m, re, fn] of ROUTES) {
      if (m === method && re.test(url)) {
        await new Promise((r) => setTimeout(r, 240));
        return { data: fn(config, re.exec(url)), status: 200, statusText: 'OK', headers: {}, config };
      }
    }
    // graceful fallback for any other /api/agent/* call so no screen errors
    if (url.includes('/api/agent/')) {
      await new Promise((r) => setTimeout(r, 200));
      const body = method === 'GET'
        ? (/(summary|me|preferences|ledger|tree|roadmap|count)$/.test(url) ? ok({}) : page([], config))
        : ok({ ok: true });
      return { data: body, status: 200, statusText: 'OK', headers: {}, config };
    }
    return fallback(config);
  };
}
